var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"members-wrap"},_vm._l((_vm.members),function(member){return _c('div',{staticClass:"member-card_inner-link"},[_c('MembersItem',{key:member.id,attrs:{"member":member,"active":_vm.user_is_active}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }